<template>
  <div class="zip4">
    {{ uspsZipLookup }}
  </div>
</template>
<script>
import { getZip4 } from '@/libraries/api/usps'

export default {
  name: 'Zip4',
  props: ['place'],
  data () {
    return {
      componentForm: {
        administrative_area_level_1: 'short_name',
        postal_code: 'short_name',
      },
      zip4: '',
    }
  },
  asyncComputed: {
    uspsZipLookup () {
      const response = this.sendRequestToUsps(this.getAddressObject())
      this.passZip4ToParent(this.zip4)
      return response
    },
  },
  methods: {
    getAddressObject () {
      if (!this.place) {
        return undefined
      }
      const addressComponents = []

      for (var component in this.place.address_components) {
        let addressType = this.place.address_components[component].types[0]
        if (this.componentForm[addressType]) {
          let val = this.place.address_components[component][this.componentForm[addressType]]
          addressComponents.push(val)
        }
      }

      let address = {
        address1: '',
        address2: this.place.name,
        city: this.place.vicinity,
        state: addressComponents[0],
        zip: addressComponents[1],
      }
      if (!address) {
        console.log('Please make sure your address correct')
      }
      return address
    },
    sendRequestToUsps (request) {
      if (!request) {
        return undefined
      }
      return getZip4(request).then(response => response.data).then(data => {
        if (data.ok) {
          if (data.zip4) {
            this.zip4 = data.zip4
            return data.zip4
          } else {
            this.$emit('error')
            this.zip4 = ''
          }
        }
      })
        .catch(error => {
          console.log(`Error: `, error)
        })
    },
    passZip4ToParent (zip) {
      this.$emit('getZip4', zip)
    },
  },
}
</script>
<style>
.zip4 {
  visibility: hidden;
}
</style>
